import angular from "angular";
import { ScoringCardsClient } from "@topline/services/apiService";
import { ResponseHandlerService } from "@topline/services/responseHandlerService";
import { MarketEditService } from "./services/marketEditService";
import { Gen } from "@topline/services/api";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { CountryService } from "../../Modules/Configuration/services/countryService";
import { ForecastParametersProvider } from "../../Modules/Forecast/services/forecastParametersProvider";
class MarketConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider
            .state("market", {
                abstract: true,
                resolve: {
                    translateReady: [angularServicesNames.$translate, ($translate: ng.translate.ITranslateService) => $translate.onReady()]
                }
            })
            .state("market.edit-ims", {
                url: "^/market/ims/edit/:id",
                template: require("./marketEdit.html"),
                controller: "marketEditController",
                controllerAs: "$ctrl",
                resolve: {
                    market: [
                        MarketEditService.componentName,
                        "$stateParams",
                        ResponseHandlerService.componentName,
                        (
                            marketEditService: MarketEditService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: ResponseHandlerService
                        ) =>
                            marketEditService
                                .get($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [404], "unauthorized")
                                )
                    ],
                    editable: [
                        MarketEditService.componentName,
                        "$stateParams",
                        (marketEditService: MarketEditService, $stateParams: ng.ui.IStateParamsService) =>
                            marketEditService.canEdit($stateParams.id)
                    ],
                    meetsRequirements: [
                        MarketEditService.componentName,
                        "market",
                        (marketEditService: MarketEditService, market: $TSFixMe) =>
                            marketEditService.checkIMSMarketRequirements(market.filters, market.kamsoftMarketType)
                    ]
                }
            })
            .state("market.edit-file", {
                url: "^/market/file/edit/:id",
                template: require("./marketInternationalEdit.html"),
                controller: "marketInternationalEditCtrl",
                controllerAs: "$ctrl",
                resolve: {
                    market: [
                        MarketEditService.componentName,
                        "$stateParams",
                        ResponseHandlerService.componentName,
                        (
                            marketEditService: MarketEditService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: ResponseHandlerService
                        ) =>
                            marketEditService
                                .getFileBased($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [404], "unauthorized")
                                )
                    ],
                    editable: [
                        MarketEditService.componentName,
                        "$stateParams",
                        (marketEditService: MarketEditService, $stateParams: ng.ui.IStateParamsService) =>
                            marketEditService.canEdit($stateParams.id)
                    ],
                    forecastConfiguration: [
                        ForecastParametersProvider.componentName,
                        (forecastParametersProvider: ForecastParametersProvider) => forecastParametersProvider.getForecastDefaults()
                    ],
                    countries: [CountryService.componentName, (countryService: CountryService) => countryService.getCountries()],
                    currencies: [CountryService.componentName, (countryService: CountryService) => countryService.getCurrencies()]
                }
            })
            .state("market.edit-scoringcards", {
                url: "^/market/scoringcards/edit/:id",
                template: require("./marketScoringCardsEdit.html"),
                controller: "marketScoringCardsEditCtrl",
                controllerAs: "$ctrl",
                resolve: {
                    market: [
                        MarketEditService.componentName,
                        "$stateParams",
                        ResponseHandlerService.componentName,
                        (
                            marketEditService: MarketEditService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: ResponseHandlerService
                        ) =>
                            marketEditService
                                .getScoringCardBased($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [404], "unauthorized")
                                )
                    ],
                    projects: [
                        ScoringCardsClient.componentName,
                        (apiClient: ScoringCardsClient) => apiClient.getProjects(Gen.ProjectCardMarketType.International)
                    ],
                    editable: [
                        MarketEditService.componentName,
                        "$stateParams",
                        (marketEditService: MarketEditService, $stateParams: ng.ui.IStateParamsService) =>
                            marketEditService.canEdit($stateParams.id)
                    ]
                }
            })
            .state("market.edit-scoringcardspoland", {
                url: "^/market/scoringcardsPoland/edit/:id",
                template: require("./marketScoringCardsPolandEdit.html"),
                controller: "marketScoringCardsPolandEditCtrl",
                controllerAs: "$ctrl",
                resolve: {
                    market: [
                        MarketEditService.componentName,
                        "$stateParams",
                        ResponseHandlerService.componentName,
                        (
                            marketEditService: MarketEditService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: ResponseHandlerService
                        ) =>
                            marketEditService
                                .getScoringCardPolandBased($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [404], "unauthorized")
                                )
                    ],
                    projects: [
                        ScoringCardsClient.componentName,
                        (apiClient: ScoringCardsClient) => apiClient.getProjects(Gen.ProjectCardMarketType.Poland)
                    ],
                    editable: [
                        MarketEditService.componentName,
                        "$stateParams",
                        (marketEditService: MarketEditService, $stateParams: ng.ui.IStateParamsService) =>
                            marketEditService.canEdit($stateParams.id)
                    ],
                    meetsRequirements: [
                        MarketEditService.componentName,
                        "market",
                        (marketEditService: MarketEditService, market: $TSFixMe) =>
                            marketEditService.checkScoringCardsPolandMarketRequirements(
                                market.filters,
                                market.kamsoftMarketType
                            )
                    ]
                }
            })
            .state("market.list", {
                url: "^/market/list",
                template: require("./marketList.html"),
                controller: "marketListController",
                controllerAs: "$ctrl"
            })
            .state("market.definitionList", {
                url: "^/market/definition/list",
                template: require("./marketDefinitionListCtrl.html"),
                controller: "marketDefinitionListCtrl",
                controllerAs: "$ctrl",
                data: {
                    permission: "MarketDefinition_Link"
                }
            });
    }
}

angular.module("topline.modules").config(MarketConfig);
